import { parseDateISO } from '@zorro/shared/formatters';

type SortableEnrollment = { effectiveFrom: string };

export const sortEnrollments = (
  first: SortableEnrollment,
  second: SortableEnrollment
): number => {
  const firstStartOfCoverage = parseDateISO(first.effectiveFrom);

  const secondStartOfCoverage = parseDateISO(second.effectiveFrom);

  return firstStartOfCoverage.isAfter(secondStartOfCoverage) ? -1 : 1;
};
